import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class ExportService {
  private baseUrl = environment.BASE_PATH;

  constructor(
    private readonly http: HttpClient,
  ) { }

  async downloadExport() {
    const url = `${this.baseUrl}/export`;
    const result$ = this.http.get(url, { responseType: 'blob' });
    return await firstValueFrom(result$);
  }
}
